import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";

const BlogDetails = () => {
  const { slug } = useParams();
  const { langJson } = useLanguage();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlog();
    window.scrollTo(0, 0);
  }, [slug]);

  const fetchBlog = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}blogs/${slug}`);
      const responseData = await response.json();
      const data = responseData?.data?.data ?? responseData?.data ?? responseData ?? null;
      setBlog(data?.id ? data : null);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching blog:", error);
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString(undefined, {
      year: "numeric", month: "long", day: "numeric",
    });
  };

  const readingTime = (text) => {
    if (!text) return 1;
    const words = text.replace(/<[^>]*>/g, "").split(/\s+/).filter(Boolean).length;
    return Math.max(1, Math.ceil(words / 200));
  };

  return (
    <div>
      <Header />
      <div className="newsDetailPage">
        {loading ? (
          <div className="newsLoading"><p>Loading...</p></div>
        ) : !blog ? (
          <div className="newsEmpty"><p>Article not found.</p></div>
        ) : (
          <>
            <div className="newsDetailHeader">
              <div className="newsDetailContainer">
                <div className="newsDetailBreadcrumb">
                  <Link to="/blogs">{langJson?.news ?? "News"}</Link>
                  <span>/</span>
                  <span>{blog.title}</span>
                </div>
                <h1 className="newsDetailTitle">{blog.title}</h1>
                {blog.excerpt && <p className="newsDetailSubtitle">{blog.excerpt}</p>}
                <div className="newsDetailMeta">
                  {blog.author && (
                    <span className="newsDetailAuthor">
                      {langJson?.by ?? "By"} {blog.author}
                    </span>
                  )}
                  {blog.published_at && (
                    <span className="newsDetailDate">{formatDate(blog.published_at)}</span>
                  )}
                  <span className="newsDetailReadTime">
                    {readingTime(blog.description)} {langJson?.minread ?? "min read"}
                  </span>
                </div>
              </div>
            </div>

            {blog.featured_image && (
              <div className="newsDetailHeroWrap">
                <img
                  className="newsDetailHero"
                  src={IMAGE_URL + blog.featured_image}
                  alt={blog.title}
                />
              </div>
            )}

            <div className="newsDetailContainer">
              {blog.description && (
                <div
                  className="newsDetailBody"
                  dangerouslySetInnerHTML={{ __html: blog.description }}
                />
              )}

              {blog.images?.length > 0 && (
                <div className="newsDetailGallery">
                  {blog.images.map((img, i) => (
                    <img
                      key={i}
                      src={IMAGE_URL + (img.image_path || img.image || img)}
                      alt=""
                      className="newsDetailGalleryImg"
                    />
                  ))}
                </div>
              )}
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default BlogDetails;
